module.exports = __webpack_public_path__ + "media/images/online_talks/social_online-22d14d3001486685502df42e1fc41d19.png";